export const metrika = {
    data() {
        return {
            allowed: [
                2000383,
                2000497,
                2000498,
                2000499,
                2000500,
                2000501,
                2000502,
                2000482,
                2000481,
                2000484,
                2000483,
                2000486,
                2000485,
                2000503,
                2000504,
                2000487,
                2000505,
                2000506,
                2000507,
                2000508,
                2000509,
                2000510,
                2000511,
                2000488,
                2000489,
                2000490,
                2000512,
                2000491,
                2000492,
                2000493,
                2000494,
                2000495,
                2000496,
            ]

        }
    },
    methods: {
        sendData(eventId, method,counters) {
            try {
                let clientId = null;
                console.log('cntrs', JSON.parse(counters));
                let cs = JSON.parse(counters);
                if (counters?.length > 0) {
                    console.log('cntrs.code', cs[0].code);
                    window.ym(cs[0].code, 'getClientID', function (cId) {
                        clientId = cId
                    });
                }
                console.log('Client ID', clientId);
                return clientId
            }catch (e){
                console.log('Error get client id', e);
            }
        }
    },
    beforeDestroy() {

    },
}
